export default "__VITE_ASSET__B1LX4E0E__"